import React, { Fragment, ReactElement } from 'react';
import useFormValues from '../../modals/utils/use-form-values';
import { useTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import {
  ClassroomNameField,
  OrganizationNameField,
  PrimaryEducatorField,
  SchoolYearField,
  CoEducatorField,
  SecretCodeTypeField,
  ClassroomColorField
} from '../ClassroomDetailsForm/ClassroomDetailsFields';
import { Organization as OrganizationType, StudentLoginType } from 'types/schema-generated-types';

export interface ClassroomDetailsCreateProps {
  classes: any;
  organization?: OrganizationType;
  organizations?: Array<OrganizationType>;
  onLoginTypeChange?: (loginType: StudentLoginType) => void;
}

export const ClassroomDetailsCreate = ({
  classes,
  organizations
}: ClassroomDetailsCreateProps): ReactElement => {
  const { t } = useTranslation('CreateClassStep');
  const [
    ,
    primaryEducatorFieldValues,
    coeducatorFieldValues,
    schoolYearFieldValues
  ] = useFormValues(organizations);

  return (
    <Grid container spacing={8} className={classes.createContainer}>
      <Grid item xs={12} sm={6}>
        <ClassroomNameField classes={classes} t={t} name="name" autoFocus />
        <OrganizationNameField
          classes={classes}
          t={t}
          name="organization"
          values={organizations?.map(({ name, id }) => ({ label: name, value: id }))}
        />
        <PrimaryEducatorField
          values={primaryEducatorFieldValues}
          classes={classes}
          name="educator"
          t={t}
        />
        <SchoolYearField values={schoolYearFieldValues} classes={classes} name="schoolYear" t={t} />
        <CoEducatorField
          classes={classes}
          values={coeducatorFieldValues}
          name="coeducators"
          t={t}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SecretCodeTypeField classes={classes} name="secretCodeType" t={t} />
        <ClassroomColorField classes={classes} name="color" t={t} />
      </Grid>
    </Grid>
  );
};

export const ClassroomDetailsEdit = ({
  classes,
  organizations
}: ClassroomDetailsCreateProps): ReactElement => {
  const { t } = useTranslation('EditClassStep');
  const [
    ,
    primaryEducatorFieldValues,
    coeducatorFieldValues,
    schoolYearFieldValues
  ] = useFormValues(organizations);

  return (
    <Fragment>
      <ClassroomNameField classes={classes} t={t} name="name" />
      <OrganizationNameField
        classes={classes}
        t={t}
        label="Organization"
        name="organization"
        values={organizations?.map(({ name, id }) => ({ label: name, value: id }))}
      />
      <SchoolYearField values={schoolYearFieldValues} classes={classes} name="schoolYear" t={t} />
      <SecretCodeTypeField classes={classes} t={t} name="secretCodeType" />
      <ClassroomColorField classes={classes} name="color" t={t} />
      <PrimaryEducatorField
        values={primaryEducatorFieldValues}
        classes={classes}
        name="educator"
        t={t}
      />
      <CoEducatorField classes={classes} t={t} name="coeducators" values={coeducatorFieldValues} />
    </Fragment>
  );
};
